import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Text } from '@ui-lib';

import { container, image as imageStyle, initials as initialsStyle } from './Avatar.css';

interface AvatarProps {
  size?: 'small' | 'medium';
  initials?: string | null;
  imageUrl?: string | null;
}

export const Avatar = ({ size = 'small', initials, imageUrl }: AvatarProps): JSX.Element => {
  const shouldDisplayImage = !!imageUrl;
  const shouldDisplayInitials = !imageUrl && !!initials;
  const shouldDisplayPlaceholder = !shouldDisplayImage && !shouldDisplayInitials;

  return (
    <Box
      className={container({
        size,
        border: shouldDisplayImage,
      })}
    >
      {shouldDisplayImage ? <img className={imageStyle} src={imageUrl} alt="Profile avatar" /> : null}
      {shouldDisplayInitials ? (
        <Text weight="demibold" size={size === 'small' ? 'xsmall' : 'small'} className={initialsStyle}>
          {initials}
        </Text>
      ) : null}
      {shouldDisplayPlaceholder ? <FontAwesomeIcon icon={faUser} /> : null}
    </Box>
  );
};
